import { render, staticRenderFns } from "./TradeRecords.vue?vue&type=template&id=f07bb3c8"
import script from "./TradeRecords.vue?vue&type=script&lang=js"
export * from "./TradeRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports